import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IChangePasswordRequest } from '../../../../classes/change-password';
import {
	PasswordValidator,
	IPasswordValidationFields,
	PasswordValidationFields,
} from '../../../../../globals/classes/password-validator';
import { BaseComponent } from '../../../../../globals/classes/base.component';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'change-code',
	template: require('./change-code.component.html'),
})
export class ChangeCodeComponent extends BaseComponent {
	@Input() public changePassRequest: IChangePasswordRequest;
	@Input() userId: string;
	@Input() isNewChangePasswordModals: boolean = false;
	public isRebrading = AppSettings.isRebrading;
	public validation: IPasswordValidationFields;
	public isValid: boolean = false;
	public isPasswordVisible: boolean = false;

	constructor(private activeModal: NgbActiveModal) {
		super();
	}

	public ngOnInit() {
		this.validation = new PasswordValidationFields();

		this.mortalize(PasswordValidator.isValidPassAndConfirm$).subscribe(
			(val) => (this.isValid = val)
		);
	}
	public toggleVisibility() {
		this.isPasswordVisible = !this.isPasswordVisible;
	}

	public toggleModalDialog(): void {
		this.activeModal.close();
	}

	public setPreviousPassword() {
		PasswordValidator.previousPassWord = this.changePassRequest.oldPassword;
		if (!!this.changePassRequest.newPassword) {
			this.validation = PasswordValidator.CheckPreviousAndNewPassword(
				this.changePassRequest.newPassword
			);
		}
	}

	public validatePassword(value: string) {
		this.validation = PasswordValidator.CheckPreviousAndNewPassword(
			this.changePassRequest.newPassword
		);
		this.validation = PasswordValidator.checkFields(value);
		if (!!this.changePassRequest.newPasswordConfirm) {
			this.validateConfirmPassword(this.changePassRequest.newPasswordConfirm);
		}
	}

	public validateConfirmPassword(value: string) {
		this.validation = PasswordValidator.CheckPasswordConfirmation(
			value,
			this.changePassRequest.newPassword
		);
	}
}
